var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 57,
    viewBox: "0 0 79 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.2098 56.9024H48.5484H45.139H44.4027V40.0205H49.957C51.3656 40.0205 52.198 38.4294 51.3656 37.2838L40.5611 22.4226C39.8728 21.4679 38.4482 21.4679 37.7599 22.4226L26.9553 37.2838C26.123 38.4294 26.9393 40.0205 28.3639 40.0205H33.9183V56.9024H33.182H29.7725H15.0944C6.69082 56.441 0 48.6285 0 40.1637C0 34.3243 3.18534 29.2326 7.90733 26.48C7.47515 25.3184 7.25105 24.0774 7.25105 22.7726C7.25105 16.8059 12.1011 11.9847 18.1036 11.9847C19.4002 11.9847 20.6487 12.2075 21.8172 12.6371C25.2906 5.3179 32.7818 0.242188 41.4895 0.242188C52.7582 0.258099 62.0421 8.83431 63.0986 19.7654C71.7582 21.2451 78.337 29.2167 78.337 38.2384C78.337 47.8807 70.7818 56.2342 61.2098 56.9024Z",
    fill: "#B69D74"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadicon);
export default __webpack_public_path__ + "static/media/uploadicon.d310b4f3accda6e0d51f4654976a8a9a.svg";
export { ForwardRef as ReactComponent };